import moment from 'moment';
import React, { useEffect, useState, useCallback, useImperativeHandle, forwardRef } from 'react';
import SiriusSelect from '@web-common/components/UI/SiriusSelect';
import styles from './customRepeat.module.scss';
import { InputNumber, Select, Radio, Space, Button } from 'antd';
import Modal from '@web-common/components/UI/Modal/SiriusModal';
import { EnmuRecurrenceRule } from './util';
import { getWeekdayWithTimeZoneOffset } from '@web-common/utils/constant';
import CustomerDatePicker from '@/components/Layout/Customer/components/UI/DatePicker/datePicker';
import { getIn18Text } from 'api';
const MODAL_WIDTH = 400;
const DATE_FORMAT = getIn18Text('YYYYNIAN11');
const OPTIONS = [
    { value: EnmuRecurrenceRule.DAYLY, label: getIn18Text('TIAN') },
    { value: EnmuRecurrenceRule.WEEKLY, label: getIn18Text('ZHOU') },
    { value: EnmuRecurrenceRule.MONTHLY, label: getIn18Text('YUE') },
    { value: EnmuRecurrenceRule.YEARLY, label: getIn18Text('NIAN') },
];
const WEEK = [
    { value: 7, label: '日' },
    { value: 1, label: '一' },
    { value: 2, label: '二' },
    { value: 3, label: '三' },
    { value: 4, label: '四' },
    { value: 5, label: '五' },
    { value: 6, label: '六' },
];
const getWeekAndDay = (m) => {
    const mTime = (m === null || m === void 0 ? void 0 : m.clone()) || moment();
    const weekday = mTime.isoWeekday();
    const month = mTime.month();
    let temp = 1;
    let prev = mTime.subtract(7, 'd');
    while (prev.month() === month) {
        temp += 1;
        prev = prev.subtract(7, 'd');
    }
    return [temp, weekday];
};
const getRruleUntil = (json, startData) => {
    const { interval, enmuRecurrenceRule, count } = json;
    let unit = '';
    if (enmuRecurrenceRule === EnmuRecurrenceRule.DAYLY) {
        unit = 'days';
    }
    else if (enmuRecurrenceRule === EnmuRecurrenceRule.WEEKLY) {
        unit = 'weeks';
    }
    else if (enmuRecurrenceRule === EnmuRecurrenceRule.MONTHLY) {
        unit = 'months';
    }
    else if (enmuRecurrenceRule === EnmuRecurrenceRule.YEARLY) {
        unit = 'years';
    }
    return startData.clone().add({ [unit]: Number(interval) * Number(count) });
};
export const getRecurIntro = (json, freq) => {
    var _a, _b, _c;
    let str1 = '';
    let str2 = '';
    const { interval, enmuRecurrenceRule, count, byDay, byMonthDay, bySetPos, rruleUntil } = json;
    const enmuRecurrenceRuleStr = freq || (enmuRecurrenceRule === null || enmuRecurrenceRule === void 0 ? void 0 : enmuRecurrenceRule.split('/')[0]);
    if (enmuRecurrenceRuleStr === EnmuRecurrenceRule.DAYLY) {
        if (interval) {
            str1 = `每${interval === 1 ? '' : interval}天重复`;
        }
        else {
            str1 = `每天重复`;
        }
    }
    else if (enmuRecurrenceRuleStr === EnmuRecurrenceRule.WEEKLY) {
        if (byDay && ((_a = byDay[0]) === null || _a === void 0 ? void 0 : _a.length) && interval) {
            if (byDay[0].slice().sort().join('') === '12345') {
                str1 = `每${interval === 1 ? '个' : interval + '周'}工作日重复`;
            }
            else {
                const weekStr = byDay[0]
                    .sort()
                    .map(num => { var _a; return (_a = WEEK.find(w => w.value === num)) === null || _a === void 0 ? void 0 : _a.label; })
                    .map(w => `周${w}`)
                    .join('、');
                str1 = `每${interval === 1 ? '' : interval + '周的'}${weekStr}重复`;
            }
        }
        else {
            str1 = `每周重复`;
        }
    }
    else if (enmuRecurrenceRuleStr === EnmuRecurrenceRule.WEEKDAY) {
        str1 = `每个工作日重复`;
    }
    else if (enmuRecurrenceRuleStr === EnmuRecurrenceRule.MONTHLY) {
        if (interval) {
            if (byMonthDay === null || byMonthDay === void 0 ? void 0 : byMonthDay.length) {
                str1 = `每${interval === 1 ? '月' : interval + '个月'}的${byMonthDay[0]}日重复`;
            }
            else if ((bySetPos === null || bySetPos === void 0 ? void 0 : bySetPos.length) && byDay && ((_b = byDay[0]) === null || _b === void 0 ? void 0 : _b.length)) {
                const weekstr = (_c = WEEK.find(w => w.value === byDay[0][0])) === null || _c === void 0 ? void 0 : _c.label;
                str1 = `每${interval === 1 ? '月' : interval + '个月'}的第${bySetPos[0]}个周${weekstr}重复`;
            }
            else {
                str1 = `每月重复`;
            }
        }
        else {
            str1 = `每月重复`;
        }
    }
    else if (enmuRecurrenceRuleStr === EnmuRecurrenceRule.YEARLY) {
        if (interval) {
            str1 = `每${interval === 1 ? '' : interval}年重复`;
        }
        else {
            str1 = `每年重复`;
        }
    }
    if (count) {
        str2 = `${count}次后结束`;
    }
    else if (rruleUntil) {
        str2 = `到${rruleUntil.format(DATE_FORMAT)}结束`;
    }
    return str2 ? str1 + '，' + str2 : str1;
};
const defaultInterval = 1;
const defaultFreq = EnmuRecurrenceRule.DAYLY;
const defaultRadio = 1;
const defaultWeek = [moment().isoWeekday()];
const defaultRruleUntil = moment();
const defaultCount = 1;
const defaultMonthSelect = 1;
const CustomRepeat = (props, ref) => {
    const { onOk, onCancel } = props;
    const [show, setShow] = useState(false);
    const [interval, setInterval] = useState(defaultInterval);
    const [freq, setFreq] = useState(defaultFreq);
    const [radio, setRadio] = useState(defaultRadio);
    const [weekDay, setWeekDay] = useState(defaultWeek);
    const [okBtnDisabled, setOkBtnDisabled] = useState(false);
    const [startDate, setStartDate] = useState(moment());
    const [endDate, setEndDate] = useState();
    const disabledDate = useCallback((current) => {
        const tooEarly = current.isBefore(startDate, 'day');
        const tooLate = endDate ? current.isAfter(endDate, 'day') : false;
        return !!tooEarly || !!tooLate;
    }, [startDate, endDate]);
    const [rruleUntil, setRruleUntil] = useState(defaultRruleUntil);
    const [count, setCount] = useState(defaultCount);
    const [monthSelect, setMonthSelect] = useState(defaultMonthSelect);
    const showCustomRepeat = (startDate, endDate) => {
        setStartDate((startDate === null || startDate === void 0 ? void 0 : startDate.clone()) || moment());
        if (endDate) {
            setEndDate(endDate);
        }
        else {
            setEndDate(null);
        }
        reset();
        setRruleUntil((startDate === null || startDate === void 0 ? void 0 : startDate.clone()) || moment());
        setWeekDay([startDate === null || startDate === void 0 ? void 0 : startDate.clone().isoWeekday()]);
        if (endDate) {
            setRadio(2);
        }
        setShow(true);
    };
    const hideCustomRepeat = () => {
        onCancel && onCancel();
        setShow(false);
    };
    useImperativeHandle(ref, () => ({
        showCustomRepeat,
        reset,
    }));
    const changeInterval = (num) => {
        setInterval(+num);
    };
    const changeRadio = e => {
        const value = e.target.value;
        setRadio(+value);
    };
    const onChangeUntil = (date, dateString) => {
        setRruleUntil(moment(dateString, DATE_FORMAT));
    };
    const changeCount = (count) => {
        setCount(count);
    };
    const handleWeek = (week) => {
        if (weekDay.includes(+week)) {
            setWeekDay(weekDay.filter(d => d !== +week).sort((a, b) => a - b));
        }
        else {
            setWeekDay([...weekDay, +week].sort((a, b) => a - b));
        }
    };
    const renderWeek = () => {
        return (freq === EnmuRecurrenceRule.WEEKLY && (React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', marginTop: '16px' } }, WEEK.map(d => (React.createElement(Button, { className: styles.btn, type: weekDay.includes(d.value) ? 'primary' : 'default', onClick: () => handleWeek(d.value) }, d.label))))));
    };
    const renderMonth = () => {
        const day = startDate.date();
        const [week] = getWeekAndDay(startDate);
        const options = [
            { value: 1, label: `第${day}天` },
            { value: 2, label: `第${week}个${getWeekdayWithTimeZoneOffset(startDate.clone())}` },
        ];
        return (freq === EnmuRecurrenceRule.MONTHLY && (React.createElement("div", { style: { display: 'flex', justifyContent: 'flex-end', marginTop: '16px' } },
            React.createElement(Select, { style: { width: '250px' }, options: options, value: monthSelect, onChange: val => setMonthSelect(val) }))));
    };
    const handleOk = () => {
        const json = {
            interval,
            enmuRecurrenceRule: freq,
        };
        if (freq === EnmuRecurrenceRule.WEEKLY) {
            json.byDay = { 0: weekDay };
        }
        if (freq === EnmuRecurrenceRule.MONTHLY) {
            if (monthSelect === 1) {
                json.byMonthDay = [startDate.clone().date()];
            }
            else if (monthSelect === 2) {
                const [week, weekDay] = getWeekAndDay(startDate.clone());
                json.bySetPos = [week];
                json.byDay = { 0: [weekDay] };
            }
        }
        if (radio === 2) {
            json.rruleUntil = rruleUntil;
        }
        else if (radio === 3) {
            json.count = count;
            json.rruleUntil = getRruleUntil(json, startDate);
        }
        json.recurIntro = getRecurIntro(json);
        setShow(false);
        onOk && onOk(json);
    };
    const reset = () => {
        setInterval(defaultInterval);
        setFreq(defaultFreq);
        setRadio(defaultRadio);
        setRruleUntil(defaultRruleUntil);
        setCount(defaultCount);
        setWeekDay(defaultWeek);
        setMonthSelect(defaultMonthSelect);
    };
    useEffect(() => {
        const temp1 = freq === EnmuRecurrenceRule.WEEKLY && weekDay.length === 0;
        if (temp1) {
            setOkBtnDisabled(true);
        }
        else {
            setOkBtnDisabled(false);
        }
    }, [freq, weekDay]);
    const handleFreq = freq => {
        setFreq(freq);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { bodyStyle: { padding: '16px 20px 12px 20px', overflow: 'hidden' }, className: styles.customRepeat, getContainer: () => document.body, title: getIn18Text('customRepeat'), destroyOnClose: true, centered: true, closable: true, width: MODAL_WIDTH, visible: show, onOk: handleOk, okButtonProps: { disabled: okBtnDisabled }, onCancel: hideCustomRepeat },
            React.createElement("div", null,
                React.createElement("div", { className: styles.line },
                    React.createElement("div", { style: { width: '110px' } }, "\u91CD\u590D\u9891\u7387\uFF1A"),
                    React.createElement(InputNumber, { style: { width: '120px' }, max: 365, min: 1, onChange: changeInterval, value: interval }),
                    React.createElement(SiriusSelect, { size: "middle", style: { width: '120px', marginLeft: '8px' }, options: OPTIONS, value: freq, defaultValue: freq, onChange: handleFreq })),
                renderWeek(),
                renderMonth(),
                React.createElement("div", { style: { marginTop: '16px' } },
                    React.createElement("div", null, "\u7ED3\u675F\u65F6\u95F4\uFF1A"),
                    React.createElement("div", { style: { display: 'flex', marginTop: '12px' } },
                        React.createElement(Radio.Group, { onChange: changeRadio, value: radio },
                            React.createElement(Space, { direction: "vertical", size: 8 },
                                React.createElement(Radio, { className: styles.radio, disabled: !!endDate, value: 1 }, "\u4E0D\u7ED3\u675F"),
                                React.createElement(Radio, { className: styles.radio, value: 2 },
                                    React.createElement("span", { className: styles.label }, "\u7ED3\u675F\u65F6\u95F4")),
                                React.createElement(Radio, { className: styles.radio, disabled: !!endDate, value: 3 },
                                    React.createElement("span", { className: styles.label }, "\u91CD\u590D")))),
                        React.createElement("div", { style: { alignSelf: 'flex-end' } },
                            React.createElement(CustomerDatePicker, { className: styles.datePicker, disabledDate: disabledDate, allowClear: false, value: rruleUntil, format: DATE_FORMAT, disabled: radio !== 2, onChange: onChangeUntil, placeholder: "", style: { width: '100%', marginTop: '40px' } }),
                            React.createElement(InputNumber, { disabled: radio !== 3, max: 365, min: 1, onChange: changeCount, value: count, style: { width: '120px' }, className: styles.count }))))))));
};
export default forwardRef(CustomRepeat);
